
import { h, Fragment } from 'preact'
import { ArrowRight, ArrowDown, ArrowRightLong, External, Close } from '@components/icons'
import classnames from 'classnames'

import './style.less'


export const ButtonTag = ({ url, href, ...props }) => {
	const link = href || url || undefined
	const TagName = link ? 'a' : 'button'
	props.href = link
	return <TagName {...props} />
}

export const ButtonText = ({ children, icon = ArrowRight, noMove, ...props }) => {
	
	const IconComponent = props.target === '_blank' ? External : icon

	const classes = classnames(
		'button-text',
		(icon && props['icon-left']) && 'button-text--icon-left',
		(icon && !props['icon-left']) && 'button-text--icon-right',
		noMove && 'button-text--no-icon-move',
		props.class,
		props.className
	)

	delete props.class
	delete props.className
	
	return <>
		<ButtonTag class={classes} {...props }>
			<div class="button-text__text">{ children }</div>
			{icon && <div class="button-text__icon">
				<IconComponent />
			</div>}
		</ButtonTag>
	</>
}


export const ButtonLabel = ({ children, icon, active, rounded, ...props }) => {

	const IconComponent = icon;

	const classes = classnames(
		'button-label',
		rounded && 'button-label--rounded',
		(icon && props['icon-left']) && 'button-label--icon-left',
		(icon && !props['icon-left']) && 'button-label--icon-right',
		active && 'is-active',
		props.class,
		props.className
	)

	delete props.class
	delete props.className
	delete props['icon-left']


	return (
		<ButtonTag class={classes} {...props}>
			<div className="button-label__inner">
				{children}
				{icon && <div className="button-label__icon">
					<IconComponent />
				</div>}
			</div>
			<div className="button-label__inner button-label__mirror">
				{children}
				{icon && <div className="button-label__icon">
					<IconComponent />
				</div>}
			</div>
		</ButtonTag>
	)
}


export const ButtonIconArrowDown = ({ showCircleHover = false, ...props }) => {
	return (
		<ButtonTag class="button-icon" {...props}>
			<div className="button-icon__inner">
				<ArrowDown showCircleHover={showCircleHover} />
			</div>
		</ButtonTag>
	)
}

export const ButtonIconClose = ({ class: _class, className, ...props }) => {
	const classes = [
		'button-icon',
		_class, 
		className
	].filter(Boolean).join(' ')
	return (
		<ButtonTag class={classes} {...props}>
			<div className="button-icon__inner">
				<Close />
			</div>
		</ButtonTag>
	)
}


export const ButtonIconArrowDownScroll = ({ showCircleHover = false, toEl }) => {
	const clickHandler = (e) => {
		const { top, height } = e.currentTarget.getBoundingClientRect()
		window.scrollTo({
		  top: Math.max(
		  	// the button position + a margin
		  	window.pageYOffset + top + height + 40,
		  	// or the window height
		  	window.innerHeight
		  ),
		  behavior: 'smooth',
		})
	}
	return <ButtonIconArrowDown showCircleHover={showCircleHover} onClick={clickHandler} />
}


export const ButtonCircle = ({ title, subtitle, children, alignLeft = false, size = 'xx-large', ...props }) => {

	const classes = classnames(
		alignLeft && 'button-circle--align-text',
		size && `text--${size}`
	)

	delete props.class
	delete props.className
	
	return (
		<ButtonTag class={`button-circle ${classes}`}  {...props }>
			<div className="button-circle__circle stripes stripes--animate-hover"></div>
			<div className="button-circle__subtitle">
				{subtitle}
			</div>
			<div className="button-circle__title">
				{title}
			</div>
			<div className="button-circle__icon">
				<ArrowRightLong />
			</div>
		</ButtonTag>
	)
}